import { DECK_CHART_INSIDE_LABEL_DARK, DECK_CHART_INSIDE_LABEL_LIGHT, getChartInsideLabelColor } from '../../foundations/chart-colors'
import type { DivergingLikertPieceTone } from './stat-view-plan'

/** Used only when the fill cannot be measured (tests, no DOM). A light brand favourable colour is measured instead. */
const TONE_TEXT_FALLBACK: Record<DivergingLikertPieceTone, string> = {
  favorable: DECK_CHART_INSIDE_LABEL_LIGHT,
  unfavorable: DECK_CHART_INSIDE_LABEL_LIGHT,
  middle: DECK_CHART_INSIDE_LABEL_DARK,
  mixed: DECK_CHART_INSIDE_LABEL_DARK,
}

/**
 * A repeated tone steps from a tint of itself up to the full token. One piece
 * stays the token. Shared by the survey plot and the deck bar, so a point
 * distribution paints the same way on both.
 */
export function divergingLikertScaledFill(color: string, intensity: number): string {
  if (intensity >= 0.999) {
    return color
  }
  const percent = Math.round(intensity * 100)
  return `color-mix(in srgb, ${color} ${percent}%, var(--slide-bg, #ffffff) ${100 - percent}%)`
}

/** Pale steps take ink. The full pole keeps the light caption the solid tone already uses. */
export function divergingLikertScaledText(tone: DivergingLikertPieceTone, intensity: number, fill: string): string {
  if (intensity >= 0.999) {
    return getChartInsideLabelColor(fill, { fallback: TONE_TEXT_FALLBACK[tone] })
  }
  if (intensity >= 0.75 && (tone === 'favorable' || tone === 'unfavorable')) {
    return TONE_TEXT_FALLBACK[tone]
  }
  return DECK_CHART_INSIDE_LABEL_DARK
}
